import React from "react";
import { defineMessages } from "react-intl";
import { localizedTransactionFilterType } from "../../../intl/shared-resources/transactionType.js";
import { makeStyles } from "tss-react/mui";
import "../../../components/filter/FilterGroupNew.js";
import "moment-timezone";
import "../../../components/input/validation.js";
import "../../../components/input/DatePicker.js";
import "../../../components/input/DateRangePicker.js";
import "../../../components/input/StyledInput.js";
import "../../../components/input/FormInput.js";
import "../../../components/input/StyledFormInputHoc.js";
import { removeItemsFromArray } from "../../../utils/array.js";
import "../../../components/input/DateSinglePicker.localize.js";
import "../../../components/input/hooks.js";
import "@mui/material";
import "../../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../../components/filter/date-filter/DateFilter.js";
import "../../../components/filter/TextFilterWithDropdown.js";
import "../../../components/filter/MultiStepFilterDrawer.js";
import "../../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import { SelectFilter } from "../../../components/filter/SelectFilter.js";
import "../../../components/filter/TextFilter.js";
import "../../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../../components/filter/dateRangeFilter/localized.js";
import "../../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../../components/filter/MultiStepFilterApplyButton.js";
import "../../../components/filter/MultiStepFilterInput.js";
import "../../../components/filter/MultiStepFilterHoc.js";
import "../../../components/select/Select.js";
import "../../../components/chip/ChipRenderer.js";
import "../../../components/select/selectStyle.js";
import "../../../components/select/MultiSelectFooter.js";
import "../../../components/select/MultiSelect.js";
import "../../../components/select/MultiSelectItem.js";
import "../../../components/select/SelectArrowIcon.js";
import "../../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../../components/select/SingleSelect.js";
import "../../../components/select/MultiSelectWithExclude.js";
import "../../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../../components/filter/PhoneFilter.js";
import { TransactionType } from "../../../contract/pam.js";
import { TransactionFilterTypeTypeName } from "../constants.js";
const localized = defineMessages({
  filterType: {
    id: "TransactionFilterType_filterType",
    defaultMessage: "Type"
  },
  wagerComponents: {
    id: "TransactionFilterType_wagerComponents",
    defaultMessage: "Wager Components"
  }
});
const availableTransactionTypes = [
  TransactionType.Bonus,
  TransactionType.BuyIn,
  TransactionType.BuyOut,
  TransactionType.Credit,
  TransactionType.Debit,
  TransactionType.Deposit,
  TransactionType.RevenueShare,
  TransactionType.Withdrawal,
  TransactionType.MttDebit,
  TransactionType.MttCredit,
  TransactionType.PokerAddonCredit,
  TransactionType.PokerAddonDebit,
  TransactionType.PokerFlipsPayout,
  TransactionType.PokerFlipsWager,
  TransactionType.CasinoWager,
  TransactionType.CasinoPayout,
  TransactionType.CasinoFreeSpinWager,
  TransactionType.CasinoFreeSpinPayout,
  TransactionType.CasinoWagerRefund,
  TransactionType.CasinoPayoutRefund,
  TransactionType.CasinoFreeSpinWagerRefund,
  TransactionType.CasinoFreeSpinPayoutRefund,
  TransactionType.P2PTransferCredit,
  TransactionType.P2PTransferDebit,
  TransactionType.Chargeback,
  TransactionType.Refund,
  TransactionType.Reverse,
  TransactionType.LiveEventBuyIn,
  TransactionType.SportsBuyin,
  TransactionType.SportsBuyout,
  TransactionType.SportsBetSettlement,
  TransactionType.Payin,
  TransactionType.Payout,
  TransactionType.PayoutReturn
];
const availableTransactionFilterOptions = [...availableTransactionTypes, "FEES"];
const availableTransactionFilterValues = [
  ...availableTransactionTypes,
  TransactionType.Fee,
  TransactionType.FeeReverse
];
const wagerGroupOptionValue = [
  TransactionType.BuyIn,
  TransactionType.MttDebit,
  TransactionType.PokerAddonDebit,
  TransactionType.PokerFlipsWager,
  TransactionType.CasinoWager,
  TransactionType.CasinoFreeSpinWager,
  TransactionType.CasinoFreeSpinWagerRefund,
  TransactionType.CasinoWagerRefund,
  TransactionType.LiveEventBuyIn,
  TransactionType.SportsBuyin
];
const useClasses = makeStyles()(() => ({
  popover: {
    minWidth: "350px !important"
  }
}));
function TransactionTypeFilter({ value, onChange }) {
  const { classes } = useClasses();
  const feesFilterKey = "FEES";
  const feesValues = [TransactionType.Fee, TransactionType.FeeReverse];
  const filterValue = value?.some((i) => feesValues?.includes(i)) ? [...removeItemsFromArray(value, ...feesValues), feesFilterKey] : value;
  function handleFilterChange(newValue) {
    let result = [...newValue ?? []];
    if (result?.includes(feesFilterKey)) {
      result = [...removeItemsFromArray(result, feesFilterKey), TransactionType.Fee, TransactionType.FeeReverse];
    }
    onChange(result);
  }
  function getOptions() {
    return [
      {
        label: localized.wagerComponents,
        value: wagerGroupOptionValue,
        subOptions: wagerGroupOptionValue.map((i) => ({
          value: i,
          label: localizedTransactionFilterType[i]
        })),
        autoSelectOnExpand: true
      },
      ...availableTransactionFilterOptions.map((t) => ({
        label: localizedTransactionFilterType[t],
        value: t
      }))
    ];
  }
  return /* @__PURE__ */ React.createElement(
    SelectFilter,
    {
      multiple: true,
      value: filterValue,
      onChange: handleFilterChange,
      label: localized.filterType,
      chipType: TransactionFilterTypeTypeName,
      options: getOptions(),
      popoverClassName: classes.popover,
      virtualization: true
    }
  );
}
export {
  availableTransactionFilterValues,
  TransactionTypeFilter as default
};
//# sourceMappingURL=TypeFilter.js.map
